import {planTypes} from "@/common/constants";
import { getPlanLogo } from '@/common/plan-logo-map';
import { getTrackingProductNameByPlanType } from '@/aspects/trackings';

const supportCapacity = [500, 1000];
if (window.newBillingConfig?.enableLargeMeeting3k5k) {
  supportCapacity.push(3000, 5000);
}

export default {
  key: planTypes[planTypes.LARGE_MEETING],
  data () {
    return {
      logo: getPlanLogo(planTypes.LARGE_MEETING),
      title: this.$t('billing.large_meeting.title'),
      subtitle: '',
      capacityKey: 'capacity',
      planType: planTypes.LARGE_MEETING,
      description: window.newBillingConfig?.enableLargeMeeting3k5k ? this.$t('billing.large_meeting.desc_new') : this.$t('billing.large_meeting.desc'),
      totalLimitDesc: this.$t('billing.licences_limit_tips', [this.$t('billing.large_meeting.title'), this.$t('billing.planform.title.zoom_meeting_zoomonenew')]),
      configDescription: window.newBillingConfig?.enableLargeMeeting3k5k ? this.$t('billing.large_meeting.config_desc_new') : this.$t('billing.large_meeting.config_desc'),
      supportCapacity: supportCapacity,
      capacityUnitI18nKey: 'billing.participants',
    }
  },
  computed: {
    trackingPlanKey() {
      return getTrackingProductNameByPlanType(this.planType);
    },
  }
};
